/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface InvitableEventUserDto { 
    userId: string;
    firstName: string;
    lastName: string;
    avatarUrl: string;
    city: string;
    status: InvitableEventUserDto.StatusEnum;
    isPending?: boolean;
    isNameAnonymous?: boolean;
}
export namespace InvitableEventUserDto {
    export type StatusEnum = '' | 'pending' | 'joined';
    export const StatusEnum = {
        Empty: '' as StatusEnum,
        Pending: 'pending' as StatusEnum,
        Joined: 'joined' as StatusEnum
    };
}


